import { UserComponent } from 'components';
import { useIsMobile } from 'hooks';
import React from 'react';

function Detail() {
  const isMobile = useIsMobile();

  return isMobile ? <UserComponent.MobileDetail /> : <UserComponent.Detail />;
}

export default Detail;
